import type { AuxiliaryBillingProduct } from "@/react/api/auxiliaryBillingCyclesApi";
import type { InvoiceStatus } from "@/react/components/SettingsApp/Plan/hooks/useAccountInvoicesInfiniteQuery";

import { absolutePath } from "./absolutePath";

interface InvoicesParams {
  exclude_status?: InvoiceStatus | InvoiceStatus[];
  order?: Record<string, "asc" | "desc">;
  page?: number;
  per_page?: number;
}

export const AccountSubscriptions = {
  getAuxiliaryBillingCycles: (
    limit?: number,
    products?: AuxiliaryBillingProduct[],
  ) =>
    absolutePath("account_subscriptions/auxiliary_billing_cycles", {
      ...(limit && { limit }),
      ...(products && { products }),
    }),
  getInvoices: (params: InvoicesParams = {}) =>
    absolutePath("account_subscriptions/invoices", params),
  getInvoiceUrl: (id: number) =>
    absolutePath(`account_subscriptions/invoices/${id}`),
  update: (planId: number, planCouponId?: number, source?: string) => {
    const payload = {
      plan_id: planId,
      ...(planCouponId && { plan_coupon_id: planCouponId }),
      ...(source && { source }),
    };
    return absolutePath("account_subscriptions", payload);
  },
  renew: (planId: number) =>
    absolutePath("account_subscriptions/renew", { plan_id: planId }),
  canDowngrade: (planId: number) =>
    absolutePath("account_subscriptions/can_downgrade", { plan_id: planId }),
  createEmailHubSubscription: () =>
    absolutePath("account_subscriptions/create_email_hub_subscription"),
  reactivateEmailHubSubscription: () =>
    absolutePath("account_subscriptions/reactivate_email_hub_subscription"),
  cancellation: () => absolutePath("account_subscriptions/cancellation"),
};
